import { useStore } from 'vuex'
import { ref } from 'vue'
import { getConfig } from '@b2ag/micro-front-tools'
import { useFeatureFlipping } from '@b2ag/feature-flipping'

import type * as Domain from './domain'
import * as PresentationModels from './presentation-models'
import * as Service from './service'

export function useRealtimeStocks(
  variants: Domain.StockVariant[],
  options: Parameters<typeof Service.fetchRealtimeStocksByVariants>[2][1],
) {
  const { isRealtimeStocksEnabled } = useFeatureFlipping()

  const isRealtimeStocksLoading = ref(false)
  const stocksInfos = ref<PresentationModels.VariantStocksInfo[]>([])

  if (isRealtimeStocksEnabled.value) {
    const store = useStore()
    const partnerId = store.getters.currentCooperativeId

    const variantIds = pluckId(variants)

    isRealtimeStocksLoading.value = true

    Service.fetchRealtimeStocksByVariants(partnerId, variantIds, [getConfig('PRODUCT_API_HOST'), options])
      .then((realtimeStocks) => {
        stocksInfos.value = PresentationModels.presentVariantStocksInfos(variants, realtimeStocks)
      })
      .finally(() => {
        isRealtimeStocksLoading.value = false
      })
  }

  return {
    isRealtimeStocksEnabled,
    isRealtimeStocksLoading,
    stocksInfos,
  }
}

function pluckId(variants: Domain.StockVariant[]): Domain.VariantId[] {
  return variants.map((variant) => variant.id)
}
